"use strict";
/* eslint-disable no-console */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentTransport = exports.setCurrentTransport = exports.transports = exports.logLevels = void 0;
exports.logLevels = ['debug', 'info', 'warn', 'error'];
exports.transports = {
    console: {
        debug: console.debug,
        info: console.info,
        warn: console.warn,
        error: console.error,
    },
};
var currentTransport = 'console';
function setCurrentTransport(transport) {
    currentTransport = transport;
}
exports.setCurrentTransport = setCurrentTransport;
function getCurrentTransport() {
    return currentTransport;
}
exports.getCurrentTransport = getCurrentTransport;
var logger = Object.fromEntries(exports.logLevels.map(function (l) { return [l, exports.transports[currentTransport][l]]; }));
exports.default = logger;
//# sourceMappingURL=logger.js.map